
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Industrialwork() {



  const cardData =
  {
    keyword: ' All Types of Industrial Work Services ',
    heading: 'Anjali Enterprises: All Types of Industrial Work Services',
    headingDescription: 'Anjali Enterprises offers a comprehensive range of industrial work services designed to meet the diverse needs of industries, including design, fabrication, construction, and installation. With years of experience in the field, we provide high-quality solutions that help streamline industrial processes, enhance efficiency, and ensure long-term durability.',

    topPlaces: [
      {
        title: "Industrial Design and Fabrication Services",
        description: "We provide expert industrial design and fabrication services, creating tailored solutions that meet the unique requirements of each project. Our team combines innovation with precision to deliver high-quality fabricated components and designs for your industrial needs."
      },
      {
        title: "Industrial Construction",
        description: "Anjali Enterprises specializes in industrial construction services, including building robust infrastructure for factories, warehouses, and other industrial setups. We focus on delivering high-strength, durable constructions that can withstand the demands of industrial environments."
      },
      {
        title: "Industrial Renovation Work",
        description: "Revitalize your existing industrial facilities with our renovation services. Whether it’s upgrading machinery, improving layout efficiency, or enhancing safety features, we provide comprehensive industrial renovation services that improve both functionality and aesthetics."
      },
      {
        title: "Heavy-Duty Industrial Services",
        description: "Our heavy-duty industrial services are designed to handle complex and demanding projects. From large-scale machinery installations to industrial plant construction, we ensure that every project is executed with precision and efficiency, meeting your operational needs."
      },
      {
        title: "Commercial Industrial Fabrication",
        description: "We offer commercial industrial fabrication services, specializing in the production of large-scale, customized metal structures and components. Our high-quality fabrication solutions are ideal for commercial industrial buildings, ensuring long-lasting performance."
      },
      {
        title: "Industrial Equipment Installation",
        description: "Our industrial equipment installation services ensure that your machinery and equipment are set up efficiently and safely. From initial planning to final installation, we handle every aspect of the process to ensure optimal performance and functionality."
      },
      {
        title: "Industrial Units Setup",
        description: "Anjali Enterprises provides complete industrial unit setup services, from design to execution. Whether you're establishing a new unit or upgrading an existing one, we offer tailored solutions to set up efficient and productive industrial spaces."
      },
      {
        title: "Machinery Installation",
        description: "We specialize in the installation of industrial machinery, ensuring that each piece of equipment is properly placed, calibrated, and ready for use. Our team handles everything from small-scale machinery to heavy-duty industrial equipment."
      },
      {
        title: "Warehouse Construction",
        description: "We offer warehouse construction services that are designed to meet your specific storage needs. Our solutions provide durable and scalable structures that maximize space utilization and support operational efficiency."
      },
      {
        title: "Industrial Building Services in Pune",
        description: "As a leading provider of industrial building services in Pune, Anjali Enterprises delivers high-quality, custom-built industrial structures that meet your business requirements. From planning to construction, we ensure that your industrial building is built to last."
      },
      {
        title: "Anjali Enterprises Contact Number",
        description: "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality industrial work. We specialize in all types of industrial services, including fabrication, installation, maintenance, and more, offering durable and precise solutions for various industrial applications. Get in touch for expert service and professional results. Serving Pune with top-notch industrial work tailored to your specific requirements."
      }
    ],
    tableData: [
      ["- Industrial design and fabrication services", "- Industrial construction"],
      ["- Industrial renovation work", "- Heavy-duty industrial services"],
      ["- Commercial industrial fabrication", "- Industrial equipment installation"],
      ["- Industrial units setup", "- Machinery installation"],
      ["- Warehouse construction", "- Industrial building services in Pune"]
    ],    


    "whychoose": [
      {
        "WhyChooseheading": "Expertise in Office Partitions",
        "WhyChoosedescription": "At Anjali Enterprises, we specialize in providing high-quality aluminium glass office partitions. Our team has years of experience in designing, manufacturing, and installing partitions that enhance the aesthetics and functionality of your office space."
      },
      {
        "WhyChooseheading": "Customized Solutions",
        "WhyChoosedescription": "We understand that every office has unique requirements. That's why we offer customized aluminium glass partitions that fit your space, needs, and budget. Whether it's for privacy, space optimization, or modern design, we provide solutions tailored just for you."
      },
      {
        "WhyChooseheading": "Durability and Quality",
        "WhyChoosedescription": "We use only the finest quality materials to ensure that our partitions are long-lasting, durable, and resilient. Our aluminium frames and glass are designed to withstand daily wear and tear, providing a lasting investment for your office."
      },
      {
        "WhyChooseheading": "Timely Delivery and Installation",
        "WhyChoosedescription": "At Anjali Enterprises, we value your time. We offer prompt and efficient installation services, ensuring that your office partitions are set up with minimal disruption to your business operations."
      },
      {
        "WhyChooseheading": "Affordable Pricing",
        "WhyChoosedescription": "We provide top-notch aluminium glass partitions at competitive prices. With transparent pricing and no hidden charges, we ensure you get the best value for your investment in office design."
      },
      {
        "WhyChooseheading": "Professional Team",
        "WhyChoosedescription": "Our experienced and skilled team handles everything from the initial design consultation to the final installation. We work closely with you to understand your needs and deliver a professional, hassle-free service."
      },
      {
        "WhyChooseheading": "Customer Satisfaction",
        "WhyChoosedescription": "We are committed to delivering excellent customer service. With numerous satisfied clients and repeat business, Anjali Enterprises strives to exceed your expectations with every project we undertake."
      }
    ]


  }

  const faqData = [
    {
      "question": "What types of industrial work do you specialize in?",
      "answer": "We specialize in a wide range of industrial services, including fabrication, installation, machinery maintenance, steel structures, custom solutions for manufacturing units, and more. We can handle any industrial project that requires precision and expertise."
    },
    {
      "question": "Do you offer custom solutions for industrial projects?",
      "answer": "Yes, we provide customized industrial solutions designed to meet the unique requirements of your business or project. Whether it's a special fabrication project, a machinery setup, or an installation, we tailor our services to your needs."
    },
    {
      "question": "How experienced is your team in handling industrial work?",
      "answer": "Our team consists of highly skilled and experienced professionals who have worked on numerous industrial projects. With a track record of successfully completed projects, we bring a wealth of expertise to each task."
    },
    {
      "question": "How do you ensure the quality of your industrial work?",
      "answer": "We follow strict quality control protocols at every stage of the industrial process. From material selection to project execution, we ensure that all work meets high industry standards and client specifications."
    },
    {
      "question": "Can you handle large-scale industrial projects?",
      "answer": "Yes, we have the resources and capabilities to manage large-scale industrial projects. Whether it’s a major installation or a complex machinery setup, we have the experience and capacity to handle large-scale tasks effectively."
    },
    {
      "question": "What industries do you serve?",
      "answer": "We serve a wide range of industries, including manufacturing, construction, automotive, power, oil and gas, logistics, and more. Our industrial services are versatile and cater to the diverse needs of different sectors."
    },
    {
      "question": "How do you ensure the safety of the work environment?",
      "answer": "We prioritize safety in all our industrial projects. Our team follows strict safety guidelines, uses proper protective gear, and ensures that all work complies with industry safety regulations to maintain a safe working environment."
    },
    {
      "question": "How do you handle industrial maintenance?",
      "answer": "We offer regular maintenance services to ensure your machinery, equipment, and installations are always in optimal working condition. Our maintenance services help prevent breakdowns, improve efficiency, and extend the lifespan of your industrial assets."
    },
    {
      "question": "What is your process for starting an industrial project?",
      "answer": "Our process begins with an initial consultation where we assess your requirements. After understanding your needs, we provide a detailed plan, including timelines and costs. Once approved, we proceed with project execution, keeping you informed throughout the process."
    },
    {
      "question": "Why should I choose Anjali Enterprises for my industrial work?",
      "answer": "Anjali Enterprises offers high-quality, reliable, and affordable industrial services with a focus on customer satisfaction. We provide end-to-end solutions, custom designs, timely delivery, and a commitment to safety and quality, making us a trusted partner for all your industrial needs."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Sandeep Agarwal",
      "text": "Anjali Enterprises handled our industrial project with great professionalism. From custom fabrication to installation, everything was completed on time and to the highest standards. Their team was reliable, and we’ve been very satisfied with their services."
    },
    {
      "name": "Ms. Priya Kapoor",
      "text": "We hired Anjali Enterprises for ongoing maintenance and installations for our plant. Their expertise in industrial work has helped us avoid downtime and keep our operations running smoothly. Highly recommend their services to anyone in the industrial sector."
    }
  ];
  


  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title> Industrial Work Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers all types of industrial work services in Pune, including industrial design and fabrication, construction, renovation, equipment installation, and more. Call +91 8793220265 for expert industrial services." />
  <meta name="keywords" content="Industrial Design and Fabrication Services, Industrial Construction, Industrial Renovation Work, Heavy-Duty Industrial Services, Commercial Industrial Fabrication, Industrial Equipment Installation, Industrial Units Setup, Machinery Installation, Warehouse Construction, Industrial Building Services Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Industrial Work Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers all types of industrial work services in Pune, including industrial design and fabrication, construction, renovation, equipment installation, and more. Call +91 8793220265 for expert industrial services." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/industrial-work-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/industrial-work-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers all types of industrial work services in Pune, including industrial design and fabrication, construction, renovation, equipment installation, and more. Call +91 8793220265 for expert industrial services.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/industrial-work-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/industrial-work-service.jpg",
        "priceRange": "₹20000 - ₹100000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/industrial-work-services",
          "priceCurrency": "INR",
          "price": "20000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "40"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikas P"
            },
            "datePublished": "2024-06-18",
            "reviewBody": "Anjali Enterprises helped us with industrial renovation and machinery installation. The work was completed on time and with great quality. Very professional team!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suresh M"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "We hired Anjali Enterprises for setting up our industrial unit. Their design and fabrication services were exceptional, and they provided a complete solution. Highly recommended!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/industrial-work-services"
        },
        "keywords": "Industrial Design and Fabrication Services, Industrial Construction, Industrial Renovation Work, Heavy-Duty Industrial Services, Commercial Industrial Fabrication, Industrial Equipment Installation, Industrial Units Setup, Machinery Installation, Warehouse Construction, Industrial Building Services Pune"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/17.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Industrialwork;